import {html, LitElement, type TemplateResult} from "lit";
import {customElement} from "lit/decorators.js";
import {unsafeHTML} from "lit/directives/unsafe-html.js";
import Styles from "./disclaimerDialog.lit.scss";
import {eopCustomEvent} from "../../../common/utils/events";
import {CLOSE_DIALOG} from "./modalDialog";
import {resolve} from "../../../container";
import {ClickTracking} from "../../../tracking/clickTracking";

@customElement("eop-disclaimer-dialog-content")
export class DisclaimerDialogContent extends LitElement {

    public static readonly styles = Styles;

    public constructor(
        private headline: string,
        private content: string,
        private url: string,
        private acceptLabel: string,
        private declineLabel: string,
        private clickTracking: ClickTracking = resolve(ClickTracking)
    ) {
        super();
    }

    public render(): TemplateResult {
        return html`
            <div class="disclaimer-dialog">
                <h2 class="h">${this.headline}</h2>
                <div>${unsafeHTML(this.content)}</div>
                <div class="disclaimer-footer">
                    <a href=${this.url} target="_blank" class="button-ok primary" @click=${this.acceptCallback}>
                        ${this.acceptLabel}
                    </a>
                    <button type="button" class="button-cancel secondary" @click=${this.declineCallback}>
                        ${this.declineLabel}
                    </button>
                </div>
            </div>
        `;
    }

    private acceptCallback(event: Event): void {
        this.trackButton(event, this.acceptLabel);
    }

    private declineCallback(event: Event): void {
        this.trackButton(event, this.declineLabel);
        this.dispatchEvent(eopCustomEvent(CLOSE_DIALOG));
    }

    private trackButton(event: Event, text: string): void {
        event.stopPropagation();
        this.clickTracking.handleButtonInteract(event, text);
    }
}

export namespace DisclaimerDialogFactory {
    export function create(
        headline: string,
        content: string,
        url: string,
        acceptLabel: string,
        declineLabel: string
    ): DisclaimerDialogContent {
        return new DisclaimerDialogContent(headline, content, url, acceptLabel, declineLabel);
    }
}